import IJitRepository from '../domain/IJitRepository';
import jitRepository from '../infrastructure/repositories/JitRepository';

class EditCommentUseCase {
  private readonly jitRepository: IJitRepository;

  constructor({ repository }) {
    this.jitRepository = repository;
  }

  execute({
    code,
    body
  }: {
    code: string;
    body: {
      text: string;
    };
  }) {
    return this.jitRepository.updateComment({ code, body }).then((res) => res);
  }
}

export { EditCommentUseCase };
export default new EditCommentUseCase({
  repository: jitRepository
});
